import {PickupState} from './interfaces'

export const getInitialState = (): PickupState => {
    return {
        merchantName: '',
        productType: 'NORMAL',
        status: 'INACTIVE',
        location: {
            address: '',
            point: {
                x: '',
                y: '',
            },
            imageUrl: '',
            markerColor: '#ffffff',
        },
    }
}
